import * as React from 'react';
import {FunctionComponent} from 'react';
import {ReportRowType, TrendTemplate} from './Models/ReportTemplate';
import {classNames} from '../../../Support/classNames';
import {ReportField} from '../Models/ReportField';

interface OwnProps {
    startAddingTrend: () => void;
    addTrendTemplate: (trendTemplate: TrendTemplate) => void;
    className?: string;
}

export const TemplateCards: FunctionComponent<OwnProps> = ({startAddingTrend, addTrendTemplate}) => {
    return (
        <div className={classNames('row mt-3')}>
            <div className="col-4">
                <div className="card mb-3">
                    <div className="card-body">
                        <h5>Performance</h5>
                        <p>Track performance overtime, add standardised tests to compare.</p>
                        <button
                            className="btn btn-secondary"
                            onClick={() =>
                                addTrendTemplate({
                                    title: 'Performance',
                                    rows: [
                                        {
                                            type: ReportRowType.Table,
                                            fields: [
                                                ReportField.ExecutedAt,
                                                ReportField.AverageSplit,
                                                ReportField.AveragePower,
                                            ],
                                        },
                                        {
                                            type: ReportRowType.Graph,
                                            x: ReportField.ExecutedAt,
                                            y: ReportField.AverageSplit,
                                        },
                                    ],
                                })
                            }
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-4">
                <div className="card mb-3">
                    <div className="card-body">
                        <h5>Ranking</h5>
                        <p>Who's most committed to the training? Add all workouts to this report to gain insights.</p>
                        <button
                            className="btn btn-secondary"
                            onClick={() =>
                                addTrendTemplate({
                                    title: 'Ranking',
                                    rows: [
                                        {
                                            type: ReportRowType.Table,
                                            fields: [
                                                ReportField.ExecutedAt,
                                                ReportField.ElapsedTime,
                                                ReportField.TraveledDistance,
                                            ],
                                        },
                                    ],
                                })
                            }
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-4">
                <div className="card mb-3">
                    <div className="card-body">
                        <h5>Qualitative</h5>
                        <p>
                            Focus on improving technique, to make the most out of this report register similar sessions
                            sessions focusing on form.
                        </p>
                        <button
                            className="btn btn-secondary"
                            onClick={() =>
                                addTrendTemplate({
                                    title: 'Qualitative',
                                    rows: [
                                        {
                                            type: ReportRowType.Table,
                                            fields: [
                                                ReportField.ExecutedAt,
                                                ReportField.AverageRSquaredTotalStroke,
                                                ReportField.AverageStrokeLength,
                                                ReportField.AverageRelativePeakForcePosition,
                                            ],
                                        },
                                    ],
                                })
                            }
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-4">
                <div className="card mb-3">
                    <div className="card-body">
                        <h5>Custom</h5>
                        <p>Choose data points and metrics that matter to you.</p>
                        <button className="btn btn-secondary" onClick={() => startAddingTrend()}>
                            Add trend
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
